window.addEventListener('DOMContentLoaded', (event) => {
  document.referrer ? document.querySelectorAll('.go-back').forEach(btn => btn.href = document.referrer) : null;
});
jQuery(document).ready(function() {
      $('#abz_collections').owlCarousel({
         loop:true,
         nav : true,
         dots:false,
         margin:0,
         responsiveClass:true,
         responsive:{
          0:{
            items:2,
            nav:true
        },
        480:{
            items:2,
            nav:true
        },
        1000:{
            items:2,
            nav:true
        },
        1100:{
            items:4,
            nav:true,
            loop:false
        },
        1200:{
            items:5,
            nav:true,
            loop:false
        }
        }
      })

       $('#abz-new-multicol').owlCarousel({
         loop:true,
         nav : false,
         dots:false,
         margin:20,
         responsiveClass:true,
         responsive:{
          0:{
            items:1,
            nav:false
        },
        750:{
            items:2,
            nav:false,
            autoplay:true,
            autoplayTimeout:1000
        },
        1200:{
            items:3,
            nav:false,
            loop:false
        }
        }
      })

      $('#abz-review-sec').owlCarousel({
         loop:true,
         nav : false,
         dots:false,
         margin:20,
         responsiveClass:true,
         responsive:{
          0:{
            items:1,
            nav:false
        },
       768:{
            items:2,
            nav:false
        },
        990:{
            items:3,
            nav:false,
            loop:false
        }
        }
      })

     $('#abz_logo_img').owlCarousel({
         loop:true,
         nav : false,
         dots:false,
         margin:20,
         responsiveClass:true,
         items:6,
         responsive:{
          0:{
            items:3.5,
            nav:false
        },
        480:{
            items:4.5,
            nav:false
        },
        641:{
            items:5,
            nav:false
        },
        1000:{
            items:5,
            nav:false,
            loop:false
        },
        1200:{
            items:6,
            nav:false,
            loop:false
        }
        }
      })
   
    });

$( document ).ready(function() {
   $( ".owl-prev").html('<img src="https://cdn.shopify.com/s/files/1/0680/3977/0424/files/arrow-left.svg?v=1672815833" alt="arrow-left">');
   $( ".owl-next").html('<img src="https://cdn.shopify.com/s/files/1/0680/3977/0424/files/arrow-right.svg?v=1672815911" alt="arrow-right">');

});

$(document).ready(function (){
  
  $(".open").click(function (){
    $(".pop-outer").fadeIn("slow");
  });
  $(".close").click(function (){
    $(".pop-outer").fadeOut("slow");
  });
});


$('.abz-slider-data').owlCarousel({
    loop:true,
    margin:10,
    nav : false,
    dots:false,
    responsive:{
        0:{
            items:1.5
        },
        641:{
            items:2
        },
        990:{
            items:3
        },
        1000:{
            items:4
        },
        1200:{
            items:5
        }
    }
});

$('#abz-mob-announcement').owlCarousel({
    loop:true,
    margin:10,
    nav : false,
    dots:false,
    responsive:{
        0:{
            items:1
        },
        991:{
            items:3
        }
    }
});

$('#abz-multicol-data').owlCarousel({
    loop:true,
    margin:10,
    nav : false,
    dots:false,
    responsive:{
        0:{
            items:1
        },
        1000:{
            items:2
        },
        1300:{
            items:3
        }
    }
});

// document.querySelector('#ProductInfo-template--16888484495672__main > variant-radios > fieldset:nth-child(2) > div > button.open.abz-btn-pop.abz-size-chart-ques').style.display = 'none';
document.querySelector('.abz-btn-pop.abz-size-chart-ques')?.style.setProperty('display', 'none');
